import { createAsyncThunk } from '@reduxjs/toolkit';

import transactionModel from '@/models/transaction';

export const fetchPublicTransaction = createAsyncThunk(
	'share/fetchPublicTransaction',
	async (publicId, { rejectWithValue }) => {
		try {
			const transaction =
				await transactionModel.getPublicTransaction(publicId);
			if (!transaction || !transaction.path) {
				throw new Error('Invalid transaction response');
			}

			return {
				filePath: transaction.path,
				status: 'completed',
				metadata: {
					originalFileName: transaction.name
				}
			};
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
